import api from '@/apis/agreement';
import { authState } from '@/recoil/auth';
import { useRecoilValue } from 'recoil';
import { useQuery, useMutation } from 'react-query';
import {
  Agreement,
  AgreementCheckParams,
  AgreementDto,
  AgreementSubType,
  AGREEMENT_SUB_TYPE,
  updateAgreementCheckRequestParam
} from '@/apis/agreement/interface';
import GlobalAlert from '@/components/GlobalAlert';
import { AxiosError } from 'axios';
import { getErrorMessage } from '@/utils/error';
import { useHistory } from 'react-router-dom';

const getTermImage = (agreementSubType: AgreementSubType) => {
  switch (agreementSubType) {
    case AGREEMENT_SUB_TYPE.TERMS_AND_CONDITIONS:
      return 'serviceUseTerm.png';
    case AGREEMENT_SUB_TYPE.CONSIGNMENT_CONTRACT:
      return 'privacyConsignment.png';
  }
};

const parseAgreements = (agreements: AgreementDto[]): Agreement[] => {
  return agreements.map(agreement => {
    const [title, rawSubtitle] = agreement.title.split('(');
    const subtitle = rawSubtitle?.replace(')', '') ?? '';
    const image = getTermImage(agreement.agreementSubType);
    return { ...agreement, isChecked: false, subtitle, image, title };
  });
};

const useAgreementQuery = () => {
  const history = useHistory();
  const { token } = useRecoilValue(authState);

  const getAgreementsChecked = (params: AgreementCheckParams) => {
    return useQuery(
      ['getAgreementChecked'],
      () => api.getAgreementsChecked(token, params),
      {
        enabled: !!token
      }
    );
  };

  const getAgreements = (params: AgreementCheckParams) => {
    return useQuery(['getAgreements'], () => api.getAgreements(token, params), {
      select: (agreements: AgreementDto[]) => {
        return parseAgreements(agreements);
      },
      enabled: !!token
    });
  };

  const updateAgreementChecked = useMutation(
    (agreementForm: updateAgreementCheckRequestParam) =>
      api.updateAgreementsChecked(token, agreementForm),
    {
      onSuccess: () => {
        GlobalAlert.show({
          title: '약관 동의',
          body: '약관 동의가 완료되었습니다.',
          buttons: [
            {
              text: '확인',
              onClick: () => {
                history.push('/');
                GlobalAlert.hide();
              }
            }
          ]
        });
      },
      onError: (err: AxiosError) => {
        GlobalAlert.show({ title: getErrorMessage(err) });
      }
    }
  );

  return {
    getAgreementsChecked,
    getAgreements,
    updateAgreementChecked
  };
};

export default useAgreementQuery;
